import React from 'react';
import { useSelector } from 'react-redux';
import { loadingIndicator } from './loadingIndicator';
import { Wrapper } from './styled';
const Loading = () => {
  const busy = useSelector(state => state.busy);
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: busy.counter !== 0 ? loadingIndicator.Start : loadingIndicator.Stop
  });
};
export default Loading;